import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, OnInit, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ScreenSizeService } from '../../core/services/screen-size.service';
import { NewsletterStore } from './store/newsletter.store';
import { TranslatePipe } from '@ngx-translate/core';
import { NewsletterHeaderComponent } from '../../shared/components/newsletter-header/newsletter-header.component';
import { NewsletterFooterComponent } from './newsletter-footer/newsletter-footer.component';
import { LanguageService } from '../../core/services/language.service';
import '@neo-ds/components/loader';

@Component({
  selector: 'app-newsletter',
  imports: [RouterOutlet, TranslatePipe, NewsletterHeaderComponent, NewsletterFooterComponent],
  templateUrl: './newsletter.component.html',
  styleUrls: ['./newsletter.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NewsletterComponent implements OnInit {
  private readonly screenSizeService = inject(ScreenSizeService);
  private readonly store = inject(NewsletterStore);
  private readonly languageService = inject(LanguageService);
  protected isLoading = this.store.loading;
  protected isPhoneOrTablet = this.screenSizeService.isPhoneOrPortraitTablet;

  ngOnInit(): void {
    this.languageService.setLanguage('de');
  }
}
